import React from "react";
import { useNavigate } from "react-router-dom";
import "./LegalPages.css";
import { useLang, LangToggle } from "../components/LangToggle";

export default function Terms() {
  const navigate = useNavigate();
  const [lang] = useLang();

  return (
    <div className="legalPage">
      <button className="legalPage__back" onClick={() => navigate("/")}>
        {lang === "fr" ? "retour" : "back"}
      </button>
      <LangToggle />

      <div className="legalPage__content">
        {lang === "fr" ? (
          <>
            <h1 className="legalPage__title">conditions générales de vente</h1>
            <p className="legalPage__muted">Dernière mise à jour : 16/05/2026</p>

            <p>
              Les présentes conditions régissent les achats effectués sur Ghetto
              Symphony (la « Boutique »). En passant commande, vous acceptez ces
              conditions.
            </p>

            <h2>1. Informations sur le vendeur</h2>
            <p>
              Nom commercial : Ghetto Symphony
              <br />
              Forme juridique : Entrepreneur individuel (micro-entreprise)
              <br />
              Exploitant : Hugo Armand Mbom
              <br />
              SIRET : 103 137 964 00013
              <br />
              Adresse : 35 Passage Clemenceau, 34000 Montpellier, France
              <br />
              Email : hugombom2005@gmail.com
              <br />
              Téléphone : +33 6 23 66 21 78
              <br />
              TVA non applicable – article 293 B du CGI.
            </p>

            <h2>2. Produits</h2>
            <p>
              Nous nous efforçons de présenter les produits avec exactitude. Les
              couleurs et détails peuvent varier selon votre écran et les
              variations de production.
            </p>

            <h2>3. Prix</h2>
            <p>
              Les prix sont indiqués en euros (€). Ghetto Symphony relevant du
              régime de la franchise en base de TVA, aucune TVA n'est appliquée.
              Les frais de livraison éventuels sont affichés au moment du paiement,
              avant validation.
            </p>

            <h2>4. Commandes</h2>
            <p>
              Une commande est confirmée une fois le paiement approuvé via le
              checkout Shopify. Vous recevez un email de confirmation. Nous nous
              réservons le droit d'annuler une commande en cas d'erreur de stock ou
              de suspicion de fraude, et procéderons alors à un remboursement
              intégral.
            </p>

            <h2>5. Drops limités</h2>
            <p>
              Les produits sont vendus en quantités limitées lors de sorties
              programmées (« drops »). Certains produits peuvent être proposés en
              précommande avant expédition. Les délais d'expédition estimés sont
              communiqués sur la page produit et/ou au paiement. Ces dates sont des
              estimations et peuvent évoluer en raison de la production et de la
              logistique. En cas de retard significatif, les clients sont informés
              par email.
            </p>

            <h2>6. Paiement</h2>
            <p>
              Les paiements sont traités de manière sécurisée via Shopify et ses
              partenaires de paiement. Nous ne conservons pas les coordonnées
              bancaires complètes.
            </p>

            <h2>7. Expédition &amp; livraison</h2>
            <p>
              Les modes et frais d'expédition sont indiqués au paiement. Les délais
              affichés par les transporteurs sont des estimations. Le client est
              responsable de l'exactitude des informations de livraison. Ghetto
              Symphony n'est pas responsable des retards imputables au transporteur
              une fois la commande remise. Sauf délai plus long clairement indiqué
              sur la page produit (ex. précommandes), les produits sont livrés dans
              un délai maximum de 30 jours à compter de la confirmation de
              commande, conformément à l'article L216-1 du Code de la consommation.
              À défaut de respect de ce délai, vous pouvez annuler la commande dans
              les conditions de l'article L216-6.
            </p>

            <h2>8. Droit de rétractation (consommateurs UE)</h2>
            <p>
              Conformément au droit de la consommation applicable, vous disposez
              d'un délai de 14 jours à compter de la réception de votre commande
              pour vous rétracter, sans avoir à motiver votre décision. Voir notre
              Politique de remboursement pour les détails et conditions.
            </p>

            <h2>9. Retours &amp; remboursements</h2>
            <p>Voir notre Politique de remboursement pour tous les détails.</p>

            <h2>10. Garanties légales</h2>
            <p>
              Indépendamment de toute politique commerciale et du droit de
              rétractation de 14 jours, tous les produits bénéficient des garanties
              légales françaises :
            </p>
            <ul>
              <li>
                la garantie légale de conformité (art. L217-3 et suivants du Code
                de la consommation) : vous disposez de 2 ans à compter de la
                délivrance pour obtenir la réparation ou le remplacement gratuit
                d'un produit non conforme ;
              </li>
              <li>
                la garantie des vices cachés (art. 1641 et suivants du Code civil) :
                vous pouvez obtenir un remboursement ou une réduction du prix pour
                un défaut caché rendant le produit impropre à son usage.
              </li>
            </ul>
            <p>
              Pour faire jouer ces garanties, contactez-nous à
              hugombom2005@gmail.com.
            </p>

            <h2>11. Responsabilité</h2>
            <p>
              Dans les limites permises par la loi, Ghetto Symphony n'est pas
              responsable des dommages indirects ou consécutifs. Aucune disposition
              des présentes ne limite les droits qui ne peuvent être exclus en vertu
              du droit de la consommation applicable.
            </p>

            <h2>12. Médiation de la consommation</h2>
            <p>
              Conformément à l'article L612-1 du Code de la consommation, après
              avoir adressé une réclamation écrite, vous pouvez recourir
              gratuitement à un médiateur de la consommation en vue de la résolution
              amiable d'un litige. Médiateur : [à désigner — nom, adresse postale et
              site web à compléter une fois le service de médiation souscrit].
            </p>

            <h2>13. Droit applicable</h2>
            <p>
              Les présentes conditions sont régies par le droit français. En cas de
              litige, les tribunaux français sont compétents, sans préjudice des
              règles impératives de protection des consommateurs applicables dans le
              pays de résidence du client.
            </p>

            <h2>14. Contact</h2>
            <p>Pour toute demande : hugombom2005@gmail.com</p>
          </>
        ) : (
          <>
            <h1 className="legalPage__title">terms of service</h1>
            <p className="legalPage__muted">Last update: 16/05/2026</p>

            <p>
              These Terms govern purchases made on Ghetto Symphony (the "Store"). By
              placing an order, you agree to these Terms.
            </p>

            <h2>1. Seller information</h2>
            <p>
              Trade name: Ghetto Symphony
              <br />
              Legal form: Entrepreneur individuel (micro-entreprise)
              <br />
              Owner: Hugo Armand Mbom
              <br />
              SIRET: 103 137 964 00013
              <br />
              Address: 35 Passage Clemenceau, 34000 Montpellier, France
              <br />
              Email: hugombom2005@gmail.com
              <br />
              Phone: +33 6 23 66 21 78
              <br />
              TVA non applicable – article 293 B du CGI.
            </p>

            <h2>2. Products</h2>
            <p>
              We do our best to display products accurately. Colors and details may
              vary depending on your screen and production variations.
            </p>

            <h2>3. Prices</h2>
            <p>
              Prices are shown in EUR (€). As Ghetto Symphony operates under the VAT
              franchise regime (franchise en base de TVA), no VAT is applied.
              Shipping fees (if applicable) are displayed at checkout before payment.
            </p>

            <h2>4. Orders</h2>
            <p>
              An order is confirmed once payment is approved via Shopify checkout.
              You will receive an order confirmation email. We reserve the right to
              cancel an order in case of stock error or fraud suspicion, and will
              issue a full refund in such cases.
            </p>

            <h2>5. Limited drops</h2>
            <p>
              Products are sold in limited quantities through timed releases
              ("drops"). Some products may be sold as preorders prior to shipping.
              Estimated shipping timing is communicated on the product page and/or at
              checkout. Dates are estimates and may change due to production and
              logistics. In case of significant delay, customers will be notified by
              email.
            </p>

            <h2>6. Payment</h2>
            <p>
              Payments are processed securely via Shopify and its payment partners.
              We do not store full payment card details.
            </p>

            <h2>7. Shipping &amp; delivery</h2>
            <p>
              Shipping methods and costs are shown at checkout. Delivery timelines
              shown by carriers are estimates. Customers are responsible for
              providing accurate shipping information. Ghetto Symphony is not liable
              for delays caused by the carrier once the order has been handed over.
              Unless a longer time is clearly indicated on the product page (e.g.
              preorders), products are delivered within a maximum of 30 days from
              order confirmation, in accordance with art. L216-1 of the French
              Consumer Code. If this deadline is not met, you may cancel the order
              under the conditions of art. L216-6.
            </p>

            <h2>8. Right of withdrawal (EU consumers)</h2>
            <p>
              In accordance with applicable EU consumer law, you have the right to
              withdraw from your purchase within 14 days of receiving your order,
              without giving any reason. Please refer to our Refund Policy for full
              details and conditions.
            </p>

            <h2>9. Returns &amp; refunds</h2>
            <p>Please refer to our Refund Policy for full details.</p>

            <h2>10. Legal guarantees</h2>
            <p>
              Independently of any commercial policy and of the 14-day right of
              withdrawal, all products benefit from the French statutory guarantees:
            </p>
            <ul>
              <li>
                the legal guarantee of conformity (garantie légale de conformité,
                art. L217-3 et seq. of the French Consumer Code): you have 2 years
                from delivery to obtain the repair or replacement of a non-conforming
                item, free of charge;
              </li>
              <li>
                the legal guarantee against hidden defects (garantie des vices
                cachés, art. 1641 et seq. of the French Civil Code): you may obtain a
                refund or a price reduction for a hidden defect that makes the item
                unfit for its intended use.
              </li>
            </ul>
            <p>
              To make a claim under these guarantees, contact us at
              hugombom2005@gmail.com.
            </p>

            <h2>11. Liability</h2>
            <p>
              To the fullest extent permitted by law, Ghetto Symphony is not liable
              for indirect or consequential damages. Nothing in these Terms limits
              rights that cannot be excluded under applicable consumer law.
            </p>

            <h2>12. Consumer mediation</h2>
            <p>
              In accordance with art. L612-1 of the French Consumer Code, once you
              have submitted a written complaint to us, you may resort free of charge
              to a consumer mediator with a view to the amicable resolution of a
              dispute. Mediator: [to be designated — name, postal address and website
              to be added once a mediation service is subscribed].
            </p>

            <h2>13. Governing law</h2>
            <p>
              These Terms are governed by French law. In case of dispute, French
              courts shall have jurisdiction, without prejudice to any mandatory
              consumer protection rules applicable in the customer's country of
              residence.
            </p>

            <h2>14. Contact</h2>
            <p>For any request: hugombom2005@gmail.com</p>
          </>
        )}
      </div>
    </div>
  );
}
